module.exports = function() {};



//////////////////
// WEBPACK FOOTER
// ./~/pjax/lib/util/noop.js
// module id = 24
// module chunks = 0